let origin = "https://future.zhuneng.cn";
//创业达人列表
const getTalentListUrl = `/gateway/hc-neighbour/topic/getTopicList`;

// 创业达人详情
const getTalentInfoByIdURL = `/gateway/hc-neighbour/topic/getTopicInfoById`;
export { getTalentListUrl, getTalentInfoByIdURL };
